<template>
	<div class="d-flex justify-content-center">
		<!-- 注册账号  -->
		<div class="login-wid login-p" v-if="event == 'login'">
			<div class="ftr-1-5 ftw600">
				{{$t('login.register')}}
			</div>
			<div class="mt-3 ftr-1-5 ftw600">
				{{$t('login.welcome')}}
			</div>
			<div class="mt-2">
				{{$t('login.hint')}} 
				<span style="text-decoration: underline;color: #547EC8;">{{$t('footers.termsofService')}}</span>
				<span>{{$t('login.and')}}</span>
				<span style="text-decoration: underline;color: #547EC8;">{{$t('login.privacyPolicy')}}</span>
			</div>
			<div class="mt-3">
				{{$t('login.email')}}
			</div>
			<div class="flex mt-2">
				<a-input v-model:value="emailNum" :placeholder="$t('login.emailAccount')"  style="height: 40px;flex: 1;" />
				<!-- 修改按鈕文本 -->
				<button 
					type="button" 
					class="btn btn-theme wid-fit ml10" 
					@click="sendEmail"
					:disabled="countdown > 0"
				>
					{{ countdown > 0 ? $t('login.retry',{countdown:countdown}) : $t('login.send') }}
				</button>
			</div>
			
			<div class="mt-2">
				{{$t('login.code')}}
			</div>
			<a-input v-model:value="captcha" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.password')}}
			</div>
			<a-input-password v-model:value="password" :placeholder="$t('login.password')" class="mt-2" style="height: 40px;"/>
			<div class="mt-2">{{$t('login.passwordHint')}}</div>
			<button type="button" class="btn btn-dark bg-theme ftw600 mt-4 py-2 cl-black" style="width: 100%;"
			@click="emailLogin"
			>{{showTitle!='edit'?$t('login.register'):$t('login.editPassword')}}</button>
			<div class="text-center mt-3">
				{{$t('login.haveAccount')}}<a href="#/login" class="cl-black">{{$t('login.toLogin')}}</a>
			</div>
		</div>
		<!-- 修改密码 -->
		<div class="login-wid login-p" v-if="event == 'edit'">
			<div class="ftr-1-5 ftw600">
				{{$t('login.editPassword')}}
			</div>
			<div class="mt-4">
				{{$t('login.currentPassword')}}
			</div>
			<a-input-password v-model:value="old_password" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.newPassword')}}
				<span class="cl-red">*</span>
			</div>
			<a-input-password v-model:value="new_password" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.confirmNewPassword')}}
				<span class="cl-red">*</span>
			</div>
			<a-input-password v-model:value="new_password_affirm" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2"><span class="cl-red">*</span>{{$t('login.passwordHint')}}</div>
			
			<button type="button" class="btn btn-dark bg-theme ftw600 mt-4 py-2 cl-black" style="width: 100%;"
			@click="changePassword()"
			>{{$t('login.editPassword')}}</button>
		</div>
		
		<!-- 忘记密码 -->
		<div class="login-wid login-p" v-if="event == 'forgot'">
			<div class="ftr-1-5 ftw600">
				{{$t('login.forgotPassword')}}
			</div>
			<div class="mt-3">
				{{$t('login.email')}}
			</div>
			<div class="flex mt-2">
				<a-input v-model:value="emailNum" :placeholder="$t('login.emailAccount')"  style="height: 40px;flex: 1;" />
				<!-- 修改按鈕文本 -->
				<button 
					type="button" 
					class="btn btn-theme wid-fit ml10" 
					@click="sendEmail"
					:disabled="countdown > 0"
				>
					{{ countdown > 0 ? $t('login.retry',{countdown:countdown}) : $t('login.send') }}
				</button>
			</div>
			
			<div class="mt-2">
				{{$t('login.code')}}
			</div>
			<a-input v-model:value="captcha" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.newPassword')}}
				<span class="cl-red">*</span>
			</div>
			<a-input-password v-model:value="f_new_password" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2">
				{{$t('login.confirmNewPassword')}}
				<span class="cl-red">*</span>
			</div>
			<a-input-password v-model:value="password" :placeholder="$t('login.codePlaceholder')" class="mt-2" style="height: 40px;" />
			<div class="mt-2"><span class="cl-red">*</span>{{$t('login.passwordHint')}}</div>
			
			<button type="button" class="btn btn-dark bg-theme ftw600 mt-4 py-2 cl-black" style="width: 100%;"
			@click="emailLogin"
			>{{$t('login.resetPassword')}}</button>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      emailNum: '',
      captcha: '',
      password: '',
      // 新增倒計時變量
      countdown: 0,
	  event:'login',
	  showTitle:'login',
	  old_password:'',
	  new_password:'',
	  new_password_affirm:'',
	  f_new_password:''
    }
  },
  created(){
	  console.log("this.$route.query.type",this.$route.query);
	  this.event = this.$route.query.type
	  this.$route.query.title?this.showTitle = this.$route.query.title:''
  },
  methods: {
    sendEmail() {
      if (this.countdown > 0) return; // 如果倒計時未結束，則不執行\
	  if(!this.emailNum){
		  this.$message.info('請輸入郵箱')
		  return
	  }
      this.$http.api('user/sendEmail', {
        email: this.emailNum,
        event: this.event
      }).then(res=>{
		  this.countdown = 60; // 初始化倒計時
		  const timer = setInterval(() => {
		    if (this.countdown > 0) {
		      this.countdown--;
		    } else {
		      clearInterval(timer);
		    }
		  }, 1000);
	  })
     
    },
	emailLogin(){
		 const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
		
		  // 测试密码是否符合规则
		  if (!regex.test(this.password)) {
		    console.log("密码无效：需要至少8个字符，包含至少一个大写字母，一个小写字母，一个数字");
			this.$message.error(this.$t('login.errorHint'))
		    return
		  }
		  if(this.showTitle!='login'&&this.f_new_password!=this.password){
			  this.$message.error('兩次密碼輸入不一致')
			  return
		  }
		  
		this.$http.api('user/emailLogin', {
		  email: this.emailNum,
		  captcha:this.captcha,
		  password:this.password,
		  type:this.showTitle=='login'?1:2
		}).then(res=>{
			console.log("res",res);
			this.$message.success(this.showTitle=='login'?this.$t('login.registeredSuccessfully'):this.$t('login.editSuccessfully'),1,()=>{
				 this.$router.go(-1);
			})
		})
	},
	changePassword(){
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
				
		 // 测试密码是否符合规则
		 if (!regex.test(this.new_password)) {
		   console.log("密码无效：需要至少8个字符，包含至少一个大写字母，一个小写字母，一个数字");
					this.$message.error(this.$t('login.errorHint'))
		   return
		 }
		 if(this.new_password!=this.new_password_affirm){
			 this.$message.error('兩次密碼輸入不一致')
			 return
		 }
		this.$http.api('user/changePassword', {
		  old_password: this.old_password,
		  new_password:this.new_password,
		  new_password_affirm:this.new_password_affirm,
		}).then(res=>{
			console.log("res",res);
			this.$message.success('修改成功',1,()=>{
				 this.$router.go(-1);
			})
		})
	}
  }
}
</script>

<style>
	.login-wid {
		width: 400px;
		padding-top: 70px;
	}

	@media (max-width:576px) {
		.login-wid {
			width: 100%;
			padding-top: 16px;
		}

		.login-p {
			padding: 16px 40px;
		}
	}
</style>